import { OrgSubFundRequest } from './types';

export const GET_ORGANIZATION_SUB_FUNDS = (
  orgSubFundRequest: OrgSubFundRequest,
  liteMode: boolean = false
) => {
  const page = orgSubFundRequest.page ? orgSubFundRequest.page : 1;
  const limit = orgSubFundRequest.limit ? orgSubFundRequest.limit : 15;
  const params = new URLSearchParams();
  if (orgSubFundRequest?.page) {
    params.set('page', page.toString());
  }
  if (orgSubFundRequest?.limit) {
    params.set('limit', limit.toString());
  }
  if (orgSubFundRequest.ids?.length) {
    orgSubFundRequest.ids?.forEach(it => {
      params.append('filter[id][]', it);
    });
  }
  if (orgSubFundRequest.reportingPeriodIds?.length) {
    orgSubFundRequest.reportingPeriodIds?.forEach(it => {
      params.append('filter[time_period_id][]', it);
    });
  }
  if (orgSubFundRequest.searchKeyword) {
    params.set('filter[entity.name]', orgSubFundRequest.searchKeyword);
  }
  const includes = liteMode
    ? `entity,timePeriod`
    : `entity,timePeriod,children,children.latestSubmission,` +
      `children.children,children.children.latestSubmission`;
  params.set('include', includes);

  return (
    `base/organizations/${orgSubFundRequest.orgId}/sub-fund?` +
    `${params.toString()}`
  );
};

export const POST_SUB_FUND = (orgId: string) => {
  return `base/organizations/${orgId}/sub-fund`;
};

export const PUT_SUB_FUND = (orgId: string, id: string) => {
  return `base/organizations/${orgId}/sub-fund/${id}`;
};

export const DELETE_SUB_FUND = (
  orgId: string,
  id: string,
  investmentId: string
) => {
  return `base/organizations/${orgId}/sub-fund/${id}?investmentId=${investmentId}`;
};

export const POST_SUB_FUND_COST = (orgId: string, id: string) => {
  return `base/organizations/${orgId}/sub-fund/${id}/cost`;
};

export const POST_NEW_REPORTING_PERIOD = (orgId: string, id: string) => {
  return `base/organizations/${orgId}/sub-fund/${id}/reporting-period`;
};

export const DELETE_SUB_FUND_COST = (
  orgId: string,
  id: string,
  investmentId: string
) => {
  return `base/organizations/${orgId}/sub-fund/${id}/cost?investmentId=${investmentId}`;
};
